import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

export default function PaymentGate() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [durum, setDurum] = useState("yukleniyor"); // yukleniyor | hata
  const [hata, setHata] = useState("");

  useEffect(() => {
    const dogrula = async () => {
      try {
        const { data, error } = await supabase.functions.invoke("verify-session", {
          body: { token },
        });

        if (error || !data?.success) {
          setHata(data?.error || "Geçersiz veya süresi dolmuş bağlantı.");
          setDurum("hata");
          return;
        }

        // Doğrulama OK → token-satin sayfasına yönlendir
        navigate("/token-kazan", { replace: true });
      } catch {
        setHata("Bağlantı hatası. Lütfen tekrar deneyin.");
        setDurum("hata");
      }
    };

    dogrula();
  }, [token]);

  if (durum === "yukleniyor") return (
    <div style={{
      minHeight: "100vh", background: "#0a0718",
      display: "flex", alignItems: "center", justifyContent: "center",
      flexDirection: "column", gap: 16, color: "#fff",
      fontFamily: "'Trebuchet MS', sans-serif",
    }}>
      <div style={{ fontSize: 40 }}>🔮</div>
      <div style={{ fontSize: 14, color: "rgba(255,255,255,0.6)" }}>Doğrulanıyor...</div>
    </div>
  );

  return (
    <div style={{
      minHeight: "100vh", background: "#0a0718",
      display: "flex", alignItems: "center", justifyContent: "center",
      flexDirection: "column", gap: 16, color: "#fff", padding: 24,
      fontFamily: "'Trebuchet MS', sans-serif", textAlign: "center",
    }}>
      <div style={{ fontSize: 40 }}>⚠️</div>
      <div style={{ fontSize: 16, fontWeight: 700 }}>Bağlantı Geçersiz</div>
      <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", maxWidth: 300 }}>{hata}</div>
      <button
        onClick={() => navigate("/")}
        style={{
          marginTop: 8, padding: "12px 24px", borderRadius: 12,
          background: "linear-gradient(135deg, #7c3aed, #a855f7)",
          border: "none", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer",
        }}
      >
        Ana Sayfaya Dön
      </button>
    </div>
  );
}
